import { Heading, Loader, Typography } from '@altify/components';

interface QuestionBoxProps {
  questionText: string;
  isLoading: boolean;
}

/**
 * Displays the question being asked with an optional loading indicator
 */
export function QuestionBox({ questionText, isLoading }: QuestionBoxProps) {
  return (
    <div className="shrink-0 rounded-l-2xl rounded-br-2xl bg-[#B393FF] p-4 flex items-center justify-between gap-4">
      <Typography size="medium" weight="medium" className="text-black">
        {questionText}
      </Typography>
      {isLoading && <Loader color="black" />}
    </div>
  );
}
